export function humanizeTimeDiff(oldTime: string, newTime: string): string {
  // Create Date objects from the string inputs
  const olderTime = new Date(oldTime);
  const newerTime = new Date(newTime);

  // Get the difference in milliseconds
  const diffMs = Math.abs(newerTime.getTime() - olderTime.getTime());

  // Convert milliseconds to minutes
  const diffMins = Math.round(diffMs / (1000 * 60));

  // If the difference is less than 60 minutes, display in minutes
  if (diffMins < 60) {
    return `${diffMins} Min${diffMins === 1 ? '' : 's'}`;
  }

  // Otherwise, convert minutes to hours and display in hours
  const diffHours = Math.round(diffMins / 60);
  if (diffHours < 24) {
    return `${diffHours} Hour${diffHours === 1 ? '' : 's'}`;
  }

  const diffDays = Math.round(diffHours / 24);
  return `${diffDays} Day${diffDays === 1 ? '' : 's'}`;
}
